<div class="p-card">
	<div class="px-4 pt-4">
		<h2>
			<span *ngIf="mode === 'create'">{{ 'routes.document.createTitleShort' | translate:{type:
				getCurrentDocumentTypeName()} }}</span>
			<span *ngIf="mode === 'edit'">{{ 'routes.document.editTitleShort' | translate:{type:
				getCurrentDocumentTypeName()} }}</span>
		</h2>
	</div>

	<form [formGroup]="documentForm" novalidate>
		<app-document-head [headFormGroup]="headFormGroup" [documentType]="documentType" [mode]="mode" [debug]="debug"
			[availableLanguages]="availableLanguages" [submitted]="formSubmitted" [disableCompanySelect]="disableCompanySelect"
			(companyChange)="handleCompanyChange($event)" (customerChange)="handleCustomerChange($event)"
			(dateChange)="handleDateChange($event)" (vatTypeChange)="handleVatTypeChange($event)"
			(languageChange)="handleLanguageChange($event)">
		</app-document-head>

		<div *ngIf="debug" class="mt-2 p-2 border bg-light">
			<h6>{{ 'routes.document.debugHeadFormGroup' | translate }}</h6>
			<pre>{{ headFormGroup.value | json }}</pre>
		</div>

		<app-document-lines *ngIf="showLinesSection" [parentForm]="documentForm" [submitted]="formSubmitted"
			[debug]="debug" [vatPercentage]="isVatApplicable ? (headFormGroup.get('vat_percentage')?.value || 0) : 0"
			(summaryChanged)="onLinesSummaryChanged($event)" (linesChanged)="onLinesChanged()">
		</app-document-lines>

		<div *ngIf="debug && showLinesSection" class="mt-2 p-2 border bg-light">
			<h6>{{ 'routes.document.debugLinesFormArray' | translate }}</h6>
			<pre>{{ {
						lines: documentForm.get('lines')?.value,
						summary: {
						amount_before_discount: documentForm.get('amount_before_discount')?.value,
						all_discount: documentForm.get('all_discount')?.value,
						payment_amount: documentForm.get('payment_amount')?.value,
						all_vat_amount: documentForm.get('all_vat_amount')?.value,
						payment_amount_including_vat: documentForm.get('payment_amount_including_vat')?.value
						}
						} | json }}</pre>
		</div>

		<div class="p-3">
			<div class="row">
				<div class="col-md-6">
					<div class="mb-3">
						<label for="invoice_note" class="form-label">{{ 'routes.document.notes' | translate }}</label>
						<textarea class="form-control" id="invoice_note" formControlName="invoice_note"
							rows="3"></textarea>
						<div *ngIf="documentForm.get('invoice_note')?.invalid && (documentForm.get('invoice_note')?.touched || formSubmitted)"
							class="text-danger mt-1">
							{{ 'routes.document.noteMaxLength' | translate }}
						</div>
					</div>
					<div class="mb-3 allocation-section"
						*ngIf="showAllocationSection"
						[attr.key]="documentForm.get('allocation_number')?.value">
						<label class="form-label d-block mb-3">{{ 'routes.document.assignment' | translate }}</label>
						<div class="d-flex gap-4 mb-3">
							<div class="form-check">
								<input class="form-check-input" type="radio" id="allocationYes"
									formControlName="allocation_number" value="1">
								<label class="form-check-label" for="allocationYes">
									{{ 'routes.document.assignmentNumber' | translate }}
								</label>
							</div>
							<div class="form-check">
								<input class="form-check-input" type="radio" id="allocationNo"
									formControlName="allocation_number" value="0">
								<label class="form-check-label" for="allocationNo">
									{{ 'routes.document.withoutAssignmentNumber' | translate }}
								</label>
							</div>
						</div>
						<!-- <div class="form-check">
							<input class="form-check-input" type="checkbox" id="sendToCustomer"
								formControlName="send_to_customer">
							<label class="form-check-label" for="sendToCustomer">
								{{ 'routes.document.sendToCustomerEmail' | translate }}
							</label>
						</div> -->
					</div>
				</div>
			</div>
		</div>

		<app-document-payments *ngIf="showPaymentsSection" [paymentsGroup]="paymentsFormGroup"
			[documentType]="documentType" [curentLang]="curentLang" [masterBank]="masterBank"
			[allBranches]="allBranches" (totalsChanged)="onPaymentTotalsChanged($event)"
			(paymentMethodAdded)="onPaymentAdded($event)" (paymentMethodRemoved)="onPaymentRemoved($event)"
			(selectedPaymentMethodChange)="onSelectedPaymentMethodChange($event)" [submitted]="formSubmitted"
			[debug]="debug" [class]="noPaymentMethods ? 'highlight-invalid' : ''">
		</app-document-payments>

		<div *ngIf="debug && showPaymentsSection" class="mt-2 p-2 border bg-light">
			<h6>{{ 'routes.document.debugPaymentsFormGroup' | translate }}</h6>
			<pre>{{ documentForm.get('payments')?.value | json }}</pre>
		</div>

		<div *ngIf="debug" class="mt-2 p-2 border bg-light">
			<h6>{{ 'routes.document.debugFullFormRaw' | translate }}</h6>
			<pre>{{ documentForm.getRawValue() | json }}</pre>
		</div>

		<div *ngIf="debug && preparedPayloadForDebug" class="mt-2 p-2 border bg-warning">
			<h6>{{ 'routes.document.debugPreparedPayload' | translate }}</h6>
			<pre>{{ preparedPayloadForDebug | json }}</pre>
		</div>

		<div class="p-3">
			<div class="d-flex justify-content-end gap-2 mt-4">
				<button type="button" class="p-button p-button-success" (click)="confirmDocument()" [disabled]="isSubmitting">
					<i class="pi pi-check-circle me-1"></i> {{ 'routes.document.confirmDocument' | translate }}
				</button>
				<button type="button" class="p-button" (click)="saveDocument()" [disabled]="isSubmitting">
					<i class="pi pi-save me-1"></i> {{ 'routes.document.saveDraft' | translate }}
				</button>
				<button type="button" class="p-button p-button-danger" (click)="goBack()">
					<i class="pi pi-arrow-left me-1"></i> {{ 'routes.document.back' | translate }}
				</button>
			</div>
		</div>
	</form>

	<div *ngIf="!documentType && mode === 'edit'">
		<p>{{ 'routes.document.loadingDocumentData' | translate }}</p>
	</div>
</div>

<p-dialog [(visible)]="taxAutorityDialogVisible" [modal]="true" [closable]="false" [style]="{width: '400px'}"
	[baseZIndex]="1100" [header]="'dialog.taxAuthority.header' | translate">
	<p>
		{{ 'dialog.taxAuthority.text' | translate }}
	</p>
	<p-footer>
		<div class="d-flex justify-content-end gap-2">
			<button pButton type="button" label="{{ 'dialog.taxAuthority.confirm' | translate }}"
				class="p-button-success" (click)="onTaxAuthorityDialogConfirm()"></button>
			<button pButton type="button" label="{{ 'dialog.taxAuthority.cancel' | translate }}"
				class="p-button-secondary" (click)="taxAutorityDialogVisible = false; isSubmitting = false"></button>
		</div>
	</p-footer>
</p-dialog>

<p-dialog [(visible)]="dialogVisible" [modal]="true" [closable]="false" [style]="{width: '400px'}" [baseZIndex]="1100"
	[header]="
	dialogType === 'vat'
	  ? ('dialog.vat.' + dialogStep + '.header' | translate)
	  : ('dialog.id.' + dialogStep + '.header' | translate)
  ">
	<div *ngIf="dialogStep === 'warning'">
		<p>
			{{ dialogType === 'vat'
			? ('dialog.vat.warning.text' | translate)
			: ('dialog.id.warning.text' | translate)
			}}
		</p>
	</div>
	<div *ngIf="dialogStep === 'edit'">
		<label>
			{{ dialogType === 'vat'
			? ('dialog.vat.edit.label' | translate)
			: ('dialog.id.edit.label' | translate)
			}}
		</label>
		<input type="text" pInputText class="p-inputtext p-component w-100 mt-2" [(ngModel)]="dialogInputValue"
			autocomplete="off" maxlength="20" />
	</div>
	<p-footer>
		<div class="d-flex justify-content-end gap-2">
			<button pButton type="button" [label]="
		  dialogStep === 'warning'
			? (dialogType === 'vat'
				? ('dialog.vat.warning.confirm' | translate)
				: ('dialog.id.warning.confirm' | translate))
			: (dialogType === 'vat'
				? ('dialog.vat.edit.confirm' | translate)
				: ('dialog.id.edit.confirm' | translate))
		" [class]="dialogStep === 'warning' ? 'p-button-warning' : 'p-button-success'"
				(click)="onDialogConfirm()"></button>
			<button pButton type="button" [label]="
		  dialogStep === 'warning'
			? (dialogType === 'vat'
				? ('dialog.vat.warning.edit' | translate)
				: ('dialog.id.warning.edit' | translate))
			: (dialogType === 'vat'
				? ('dialog.vat.edit.cancel' | translate)
				: ('dialog.id.edit.cancel' | translate))
		" class="p-button-secondary" (click)="onDialogCancel()"></button>
		</div>
	</p-footer>
</p-dialog>

<p-toast></p-toast>